<div class="modal-content">
    <h3>Histórico</h3>

    <div *ngIf="hasValue" class="container">
        <mat-table [dataSource]="audits" class="table-list" multiTemplateDataRows>
            <ng-container matColumnDef="cnpj" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">CNPJ</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ element.cnpj | cpfCnpj }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="clientName" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Nome do Cliente</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ element.clientName }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="cnae" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">CNAE</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ element.cnae }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="period" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Período de Liberação</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ element.initialDate | date:'dd/MM/yyyy' }} a {{ element.finalDate | date:'dd/MM/yyyy' }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="doneBy" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Feito por</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ getDoneBy(element) }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="action" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Ação</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ getActionLabel(element.action) }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="actionDateTime" class="table-list__column">
                <mat-header-cell *matHeaderCellDef class="header-name">Data da Ação</mat-header-cell>
                <mat-cell *matCellDef="let element" class="column-name">{{ element.actionDateTime }}</mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
        </mat-table>
    </div>

    <h5 *ngIf="!hasValue">Nenhum registro foi encontrado</h5>

    <div mat-dialog-actions align="center" >
      <div class="value-edit-table__button-container">
        <fd-button mat-button fdSecondaryLarge [content]="'Fechar'" (trigger)="close()"></fd-button>
      </div>
    </div>
</div>

